import O1HD from "../../../engines/gameEngine";
import {
    getLoveStoryListenRuleMap,
    getLoveStroySaveRuleMap,
    loveStoryData, loveStoryListenInterface, loveStoryListenRule, loveStoryListenRuleInterface,
    loveStoryPeopleMap,
    loveStoryRecord,
    loveStroySaveInterface,
    loveStroySaveRule,
    loveStroySaveRuleInterface
} from "../prefab/loveStory/loveStoryConst";
import NormalGameManager from "./NormalGameManager";
import {getChooseOptionByPeopleIdAndId, getChooseOptionsByPeopleId} from "../prefab/loveStory/config/ChooseOption";

export default class loveStoryManager{

    constructor(gameManager:NormalGameManager){
        this.gameManager = gameManager;
        this._loadData();
    }

    gameManager:NormalGameManager = null;

    private love_story_save_game_data_key:string = "love-story-save-game-data-key";
    private love_story_save_game_record_data_key:string = "love-story-save-game-record-data-key";


    private initStr:string = "";
    private initRecordStr:string = "";

    private _data:loveStoryData = {
        poeple: <loveStoryPeopleMap>{},
        saveRule: [],
        listenRule : [],
    }
    private _dataRecord: loveStoryRecord[] = [];//操作记录流水

    private _loadData(){
        let initStr = JSON.stringify(this._data);
        this.initStr = initStr;
        let dataStr = O1HD.getServices().localStorageSrv.getStorage(this.love_story_save_game_data_key) || initStr;
        if(dataStr == ""){
            dataStr = initStr;
        }
        let data = JSON.parse(dataStr);

        let initRecordStr = JSON.stringify(this._dataRecord);
        this.initRecordStr = initRecordStr;
        let dataRecordStr = O1HD.getServices().localStorageSrv.getStorage(this.love_story_save_game_record_data_key) || initRecordStr;
        if( dataRecordStr == ""){
            dataRecordStr = initRecordStr;
        }
        this._dataRecord = JSON.parse( dataRecordStr );

        this.setData(data,false);
    }

    setData(data:loveStoryData,isPlus:boolean = false){
        for (let key in data) {
            let k = data[key];
            if (k != null) {
                if (k instanceof Array) {
                    if (isPlus) {
                        this._data[key] = this._data[key].concat(k);
                    } else {
                        this._data[key] = [].concat(k);
                    }
                } else {
                    if (isPlus) {
                        this._data[key] += k;
                    } else {
                        this._data[key] = k;
                    }
                }
            }
        }
        this.writeData();
    }

    writeData(){
        O1HD.getServices().localStorageSrv.setStorage(this.love_story_save_game_data_key,JSON.stringify(this._data));
        O1HD.getServices().localStorageSrv.setStorage(this.love_story_save_game_record_data_key,JSON.stringify(this._dataRecord));
    }

    resetManager(){
        console.log("调用了！！！！！！！！！")
        this._data = JSON.parse(this.initStr);
        this._dataRecord = [];
        this.writeData();
    }

    getOnePeople(peopleId:string){
        let people = this._data.poeple[peopleId];
        return people;
    }

    addOnePeople(peopleId:string){
        let people = this.getOnePeople(peopleId);
        if(people){
            return people;
        }
        this._data.poeple[peopleId] = {
            peopleId:peopleId,
            storyRecord:[],
            registerDay : NormalGameManager._instance.getCurrentDay(),
            meCoin:0,
            otherCoin:0,
            totalCoin : 0,
            withdrawOptionArray : [],
            currDayWithdraw : 0,
        }
        //初始化一个npc的取款选项
        this.initRegisterOnePeopleWithdrawChoose(peopleId);
        this.writeData();
        return this._data.poeple[peopleId];
    }

    removeOnePeople(peopleId:string){
        let people = this.getOnePeople(peopleId);
        if(!people){
            console.log("loveStroyManager.removeOnePeople 移除失败 原因：移除不存在的npc");
            return;
        }
        delete this._data.poeple[peopleId];
        this.writeData();
    }


    /**
     * 添加关系
     * @param peopleId
     */
    addRelation( peopleId:string ){
        let people = this.getOnePeople(peopleId);
        if(!people){
            people = this.addOnePeople(peopleId);
        }
        this.writeData();
    }
    /**
     * 加一个存款记录
     * @param peopleId 对应的npc
     * @param savePeople 存入金额的npc 可以是自己或者npc
     * @param explain 存款描述
     * @param coin 金额
     * @param isAgree 是否同意  default 2
     * @param refuseReason  isAgree 为-1 时，才有显示
     * @param type 默认 1 存款， 2 取款
     */
    addOneRecord(peopleId:string,savePeople:string,explain:string,coin:number,isAgree : number , refuseReason : string , type : number = 1 ){
        let people = this.getOnePeople(peopleId);
        if(!people){
            people = this.addOnePeople(peopleId);
        }
        people.storyRecord.push( { peopleId:savePeople,explain:explain,coin:coin,agreeStatus:isAgree,
            gameHour:NormalGameManager._instance.mGameHours,gameMinute:NormalGameManager._instance.mMinute,type : type,refuseReason : refuseReason });
        //总流水再记录一遍
        this._dataRecord.push( { peopleId:savePeople,explain:explain,coin:coin,agreeStatus:isAgree,
            gameHour:NormalGameManager._instance.mGameHours,gameMinute:NormalGameManager._instance.mMinute,type : type,refuseReason : refuseReason });
        if( isAgree == 2 ){
            //如果同意
            if( coin < 0 ){
                people.totalCoin += coin;
            }else{
                if(savePeople == "自己"){
                    people.meCoin += coin;
                }else{
                    people.otherCoin += coin;
                }
                people.totalCoin += coin;
                if ( peopleId == "沈瑶瑶" && people.totalCoin > 2000000 ) {
                    NormalGameManager._instance.addOneWeChatTriggerLinkUnShift( "1107" );
                }
            }
        }
        O1HD.emit("refreshShareCount");
        this.writeData();
    }

    /**
     * 获取恋爱屋所有的金额
     */
    getAllCoins() : number {
        let personData = this.getData();
        let totalCoin : number = 0;
        for ( let personId in personData.poeple ) {
            totalCoin += (personData.poeple[personId].totalCoin);
        }
        return totalCoin;
    }

    /**
     * 注册一条取款选项
     * @param npc id
     * @param 选项 id
     */
    registerOneWithdrawChoose(peopleId:string,chooseDesc:string){
        let pOption = getChooseOptionByPeopleIdAndId(peopleId)[chooseDesc];
        let pOptionIndex:number = this.getData().poeple[peopleId].withdrawOptionArray.findIndex((value)=>{
            return chooseDesc == value.chooseDesc;
        });
        if(pOptionIndex > -1){
            console.log(" errorMsg:  加入失败：加入重复的选项  # loveStoryManager 137 ");
            return;
        }
        this.getData().poeple[peopleId].withdrawOptionArray.push(pOption);
        this.writeData();
    }

    /**
     * 自动注册所有可以注册的取款选项
     */
    autoRegisterWithdrawChoose(){
        let peoples = this.getData().poeple;
        for(let key in peoples){
            let p = peoples[key];
            let pRegisterDay = p.registerDay;
            let currentDay = this.gameManager.getCurrentDay();

            let registerDay = currentDay - pRegisterDay;

            let pChooses = getChooseOptionsByPeopleId(p.peopleId);
            for(let c of pChooses){
                if(registerDay > 0 && registerDay == c.registerDay){
                    this.registerOneWithdrawChoose(p.peopleId,c.chooseDesc);
                }
            }
        }
    }

    /**
     * 初始化一个npc的取款选项
     */
    initRegisterOnePeopleWithdrawChoose(peopleId:string){
        let p = this.getData().poeple[peopleId];
        if(!p){
            console.log("初始化npc取款选项失败：未找到对应的npc  # loveStroyManager 170");
            return;
        }
        let pChooses = getChooseOptionsByPeopleId(p.peopleId);
        for(let c of pChooses){
            if(c.registerDay == 0){
                this.registerOneWithdrawChoose(p.peopleId,c.chooseDesc);
            }
        }
    }

    /**
     * 重置一个npc的一条取款选项的参数
     */
    resetOnePeopleOneOptionParam(peopleId:string,chooseDesc:string,resetParam:{withdrawCoinsPercent?:number,withdrawSuccessFlag?:boolean,withdrawReplayContent?:string}){
        let people = this.getData().poeple[peopleId];
        if(!people){
            console.log("重置npc的取款选项参数失败 失败原因：找不到对应的npc # loveStoryManager 190");
            return;
        }
        let pConfig = people.withdrawOptionArray.find((value)=>{
            return value.chooseDesc == chooseDesc;
        });
        if(!pConfig){
            console.log("重置npc的取款选项参数失败 失败原因：对应的npc中找不到该选项 # loveStoryManager 197");
            return;
        }
        for(let key in resetParam){
            let k = resetParam[key];
            pConfig[key] = k;
        }
        this.writeData();
    }

    getData(){
        return this._data;
    }

    getDataRecord(){
        return this._dataRecord;
    }

    /**
     * 添加一条存款规则
     * @param ruleId 规则Id
     */
    addOneRule( ruleId:string ){
        let ruleMap = getLoveStroySaveRuleMap();
        let rule = ruleMap[ruleId];
        if(rule){
            let rule = {openDay:this.gameManager.getCurrentDay(),loveStroySaveId:ruleId}
            this.setData( {saveRule:[rule]},true);
            this.triggerOneRule(rule,this.getData().saveRule.length - 1);
        }
    }

    /**
     * 触发一条规则
     * @param tRule 规则的存档
     * @param index 规则在存档中的下标
     */
    triggerOneRule(tRule:loveStroySaveRule,index:number){
        let ruleId:string = tRule.loveStroySaveId;
        let rule = getLoveStroySaveRuleMap()[ruleId];
        let saveAry = rule.saveRuleAry;
        let maxDay: number = 0;
        for (let j = 0; j < saveAry.length; j++) {
            let one: loveStroySaveRuleInterface = saveAry[j];
            let oneDay = (one.intervalDay || 0) + tRule.openDay;
            if (oneDay > maxDay) {
                maxDay = oneDay;
            }
            if ((oneDay == this.gameManager.getCurrentDay() && this.gameManager.getCurrentTimeString() == (one.saveTime || "12:00")) ||
                (one.intervalDay == null && this.gameManager.getCurrentTimeString() == (one.saveTime || "12:00"))) {
                // 添加一条存款记录
                this.addOneRecord(rule.peopleId,rule.peopleId,one.explain,one.coin,2,"");
                //刷新首页数据
                O1HD.emit("normalMode.refreshLoveStoryInfo");
                this.gameManager.bannerManager.addOneBanner(`恋爱屋提示:${one.explain}`,rule.peopleId);
            }
        }
        if (this.gameManager.getCurrentDay() > maxDay && rule.isAutoDelete) {
            this.getData().saveRule.splice(index,1);
            // console.log("删除一条",index,this.getData().saveRule);
            this.writeData();
        }
    }

    triggerRules(){
        //校验存款规则
        let rules = this.getData().saveRule;
        for(let i = rules.length -1; i>=0; i--){
            let r = rules[i];
            this.triggerOneRule(r,i);
        }

        //校验监听规则
        let listenRules = this.getData().listenRule;
        for(let i = listenRules.length -1; i>=0; i--){
            let r = listenRules[i];
            this.triggerOneListenRule( r ,  i);
        }
    }

    /**
     * 添加一条监听规则
     * @param ruleId 规则Id
     */
    addOneListenRule( ruleId : string ){
        let ruleMap = getLoveStoryListenRuleMap();
        let rule = ruleMap[ ruleId ];
        if ( rule ) {
            let rule : loveStoryListenRule = { openDay:this.gameManager.getCurrentDay(),loveStoryListenId : ruleId }
            this.setData( { listenRule : [rule] },true);
            this.triggerOneListenRule( rule,this.getData().listenRule.length - 1);
        }
    }

    /**
     * 触发一条规则
     * @param tRule 规则的存档
     * @param index 规则在存档中的下标
     */
    triggerOneListenRule( tRule : loveStoryListenRule , index : number ){
        let ruleId : string = tRule.loveStoryListenId;
        let rule = getLoveStoryListenRuleMap()[ruleId];
        let saveAry = rule.listenRuleAry;
        let maxDay: number = 0;
        for (let j = 0; j < saveAry.length; j++) {
            let one: loveStoryListenRuleInterface = saveAry[j];
            let oneDay = (one.intervalDay || 0) + tRule.openDay;
            if ( oneDay > maxDay ) {
                maxDay = oneDay;
            }
            if ( ( oneDay == this.gameManager.getCurrentDay() && this.gameManager.getCurrentTimeString() == (one.saveTime || "12:00") ) ||
                ( one.intervalDay == null && this.gameManager.getCurrentTimeString() == (one.saveTime || "12:00"))) {
                // 添加一条存款记录
                if ( one.judgeSaveCoins ) {
                    //如果判断金钱 存在
                    let peopleData = this.getOnePeople( rule.peopleId );
                    if ( peopleData.meCoin < one.judgeSaveCoins ) {
                        // 弹出事件 引导用户
                        NormalGameManager._instance.openEvenRightNow( one.eventId );
                    }
                }
                if ( one.weChatLinkId ) {
                    //如果判断微信聊天 链存在
                    if ( NormalGameManager._instance.getGameData().ariseLinks.includes( one.weChatLinkId ) == false ) {
                        // 弹出事件 引导用户
                        NormalGameManager._instance.openEvenRightNow( one.eventId );
                    }
                }
            }
        }
        if ( this.gameManager.getCurrentDay() > maxDay && rule.isAutoDelete ) {
            this.getData().listenRule.splice( index ,1 );
            this.writeData();
        }
    }

}
